import {
  maxWidth600,
  maxWidth900,
  minWidth1200,
} from "themes/default/breakpoints"

export const styles = {
  container: (hasModules) => ({
    height: hasModules ? "100%" : "100dvh",
    minHeight: hasModules ? "100%" : "100dvh",
    width: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    boxSizing: "border-box",
    p: 2,
    [maxWidth600]: {
      p: 1.5,
      justifyContent: "flex-start",
    },
  }),
  smashyCharacter: {
    objectFit: "contain",
    width: "100%",
    height: "100%",
    maxWidth: "35%",
    px: 4,
    maxHeight: "100%",
    [minWidth1200]: {
      maxWidth: 500,
    },
    [maxWidth600]: {
      maxWidth: 90,
      maxHeight: 90,
      px: 0,
      py: 0,
    },
  },
  box: (theme) => ({
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 2,
    p: 2,
    width: "100%",
    overflowY: "auto",
    maxHeight: "calc(100dvh - 200px)",
    boxSizing: "border-box",
    [maxWidth600]: {
      maxHeight: "calc(100dvh - 260px)",
      p: 1.5,
    },
  }),
  content: {
    flex: 1,
    maxWidth: "60%",
    width: "100%",
    [maxWidth600]: {
      maxWidth: "100%",
      flex: "none",
    },
  },
  levelDescription: (theme) => ({
    color: theme.palette.common.black,
    lineHeight: 1.5,
    "& ul": {
      px: 2,
    },
  }),
  takeTestBtn: {
    p: ".7rem 2rem",
    minWidth: 0,
    alignItems: "center",
    height: "auto",
    lineHeight: "1em",
    userSelect: "none",
    alignSelf: "flex-start",
    textTransform: "none",
    borderRadius: 5,
    [maxWidth900]: {
      p: ".7rem 1rem",
      minWidth: 120,
    },
    [maxWidth600]: {
      p: ".6rem 1.2rem",
      minWidth: "auto",
    },
  },
  goBackButton: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
}
